__webpack_require__.p = "https://static.futunn.com/components/common-offline-activity-ticket/";